import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './support.hooks';
import { BusinessState } from '@state/business';

const WORKING_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const START_OF_WORKING_HOURS = 8;
const END_OF_WORKING_HOURS = 18;
@Component({
	selector: 'app-support',
	templateUrl: './support.component.html',
	animations: [openClose()],
	standalone: false,
})
export class SupportComponent implements OnInit {
	navService = inject(NavigationService);
	testHooks = TestHooks;
	@Output() onClose: EventEmitter<void> = new EventEmitter<void>();

	public ICON = ICON;
	public get isTeamOnline(): boolean {
		const currentTime = new Date();

		return this.isBetweenWorkingHours(currentTime);
	}

	@SelectSnapshot(BusinessState.isCollege) isCollege;

	ngOnInit(): void {}

	public close(): void {
		this.onClose.emit();
	}

	public isBetweenWorkingHours(currentTime: Date): boolean {
		const dayOfWeek = Intl.DateTimeFormat('en', {
			weekday: 'short',
			timeZone: 'America/New_York',
		}).format(currentTime);
		const currentHour = parseInt(
			Intl.DateTimeFormat('en', {
				hour: '2-digit',
				hour12: false,
				timeZone: 'America/New_York',
			}).format(currentTime),
			10,
		);

		return (
			WORKING_DAYS.includes(dayOfWeek) &&
			currentHour >= START_OF_WORKING_HOURS &&
			currentHour < END_OF_WORKING_HOURS
		);
	}
}
